import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { AuthenticationService } from '../service/authentication.service';
import { UtilService } from '../service/util.service';
import { ApiService } from '../service/api.service';
import { Constants } from '../constants/constants';
import { Router } from '@angular/router';
import { ToastService } from '../service/toast.service';
import { NavigationOptions } from '../shared/model/navigation-options.model';
import { SearchDataService } from '../service/search-data.service';
import { EnvService } from '../service/env.service';
import { NotificationService } from '../service/notification.service';
import { UserTncComponent } from '../user-tnc/user-tnc.component';
import { NgForm } from '@angular/forms';
import { fromEvent, Observable } from 'rxjs';
import { delay } from 'rxjs/operators';
import { LanguagePreferenceComponent } from '../language-preference/language-preference.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  isLoggedIn: boolean = false;
  //loginModal;
  loggedInUser: string;
  authSubscription: any;
  accountDetailFromAPI: any;
  accountCategory: string;
  accountType: string;
  isAdmin: boolean = false;
  //@ViewChild('loginForm') public loginForm: NgForm;
  issmSearchClicked = false;
  isDeveloper: boolean = false;
  isFinanceAdmin: boolean = false;
  homePageRoute: string = "/";

  searchKey: string;
  searchPlaceholder: string;

  // Notifications
  notifications = [];

  showNotification = false;
  showSearchBox = false;
  showNavigationOptions = false;

  @ViewChild('userTnc', { static: true }) public userTncComponent: UserTncComponent;
  @ViewChild('userLanguagePreference', { static: true }) public userLanguagePreferenceComponent: LanguagePreferenceComponent;

  mfaFormLabel = Constants.MFA_FORM_LABEL;
  mfaFormMessage = Constants.MFA_FORM_MESSAGE;
  smsMfaData;
  smsMfaVerificationModel;
  @ViewChild('smsMfaVerificationForm', { static: true }) public smsMfaVerificationForm: NgForm;
  isPhoneNumberVerified = false;
  mfaFormMessagePreMobileNumber = Constants.MFA_VERIFY_CODE_FORM_MESSAGE_PRE_MOBILE_NUMBER;
  mfaFormMessagePostMobileNumber = Constants.MFA_VERIFY_CODE_FORM_MESSAGE_POST_MOBILE_NUMBER;

  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService,
    private router: Router, private toast: ToastService, private searchService: SearchDataService, private env: EnvService,
    private notificationService: NotificationService) {

    if (this.env.MODE == Constants.DEVELOPER_MODE) {
      document.title = "Nissan B2B Developer";
    }

    /*this.toastr.error('everything is broken', 'Major Error', {
      timeOut: 3000
    }); */
    this.watchTokenKey();
    this.authSubscription = this.authService.authenticationState.subscribe(state => {
      console.log("Home Auth Changed : ", state, " logged in user details : ", this.authService.loggedInUser);
      var url = window.location.href;
      console.log("current route path : ", url);
      if (!url.includes("password-reset")) {
        if (state) {
          this.isLoggedIn = true;

          //  if(this.authService.isAdmin()) {
          if (this.authService.isUserRoleAllowed()) {
            if (this.authService.isUserStatusInvitedorPending()) {
              this.showUserTnC();
            } else {
              console.log("user status not pending");
              this.getAccountDetailForAdminType();
            }

            /* if (this.authService.isAdmin()) {
              this.isAdmin = true;
              this.getAccountDetail();
            } else if (this.authService.isDeveloper()) {
              this.isDeveloper = true;
              this.getAccountDetail();
            } else if (this.authService.isFinanceAdmin()) {
              this.isFinanceAdmin = true;
              this.getAccountDetail();
            } */

            // else if (this.authService.isDongleProvider()) {
            //   this.getDongleProviderDetail();
            //   this.initHeaderTitle();
            //   this.initNavigationOptions();
            //   this.router.navigate(["/provider/dashboard"]);
            //   this.homePageRoute = "/provider/dashboard";
            // }
          } else {
            this.isLoggedIn = false;
            this.authService.logout();
            this.router.navigate(["/"]);
          }
        } else {
          this.isLoggedIn = false;
          this.loggedInUser = "";
          this.router.navigate(["/"]);
        }
      }
    });
  }

  ngOnInit() {
    this.searchService.currentSearchPlaceholder.subscribe(data => {
      if (data && data.length > 0) {
        this.searchPlaceholder = data;
        this.searchKey = null;
      }
    });
    this.handleNotificationChanges();
    this.initSmsMfaVerificationModel();
  }

  showUserTnC() {
    this.userTncComponent.init();
  }

  /* showUserTnC() {
    if (this.authService.isUserStatusPending()) {
      this.userTncComponent.init();
    }
  } */


  search() {
    console.log("search clicked!");
    if (this.searchKey == undefined || this.searchKey == null || this.searchKey.trim().length <= 0) return;
    this.searchService.searchForData(this.searchKey.trim());
  }

  ngOnDestroy() {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }

  onLogOut() {
    this.authService.logout();
    this.isAdmin = false;
    this.isDeveloper = false;
    this.apiService.reset();
  }

  getAccountDetail() {
    this.utilService.showSpinner();
    this.apiService.getAccountDetail().then((data) => {
      this.utilService.hideSpinner();
      // if (!this.isAuthorized(data)) {
      //   this.toast.showError("Requested portal is not supported yet.");
      //   this.doLogout();
      //   return;
      // }
      this.accountDetailFromAPI = data;
      console.log("account detail data::", this.accountDetailFromAPI);
      this.authService.accountData = this.accountDetailFromAPI;
      this.accountCategory = this.accountDetailFromAPI.category;
      this.accountType = this.accountDetailFromAPI.type;
      console.log("Account type %s and category : %s", this.accountType, this.accountCategory);
      this.setShowSearchBox();
      this.setShowNotification();
      this.setShowNavigationOptions();
      this.initHeaderTitle();
      this.initNavigationOptions();
      this.routeToHomePage();
      this.getWebNotificationsByStatus();
      this.getPackageList();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getAccountDetail();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  isAuthorized(accountData: any): boolean {
    let allowedCategories = [Constants.RENTAL_FLEET, Constants.FLEET_MANAGEMENT_COMPANY, Constants.DEALER, Constants.CORPORATE, Constants.FINANCING_GROUP, Constants.MOBILITY_COMPANY, Constants.FIELD_SERVICE_COMPANY];
    if (this.isAdmin || this.isFinanceAdmin) {
      if (allowedCategories.includes(accountData.category)) return true;
      if (accountData.type && accountData.type == Constants.VEHICLE_SERVICE_PROVIDER) return true;
    }
    return false;
  }

  getDongleProviderDetail() {
    this.utilService.showSpinner();
    this.apiService.getDongleProviderDetail().then((data) => {
      this.utilService.hideSpinner();
      this.accountDetailFromAPI = data;
      console.log("Device Provider account detail data::", this.accountDetailFromAPI);
      this.authService.accountData = this.accountDetailFromAPI;
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getDongleProviderDetail();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  isServiceProviderAccount(): boolean {
    if (this.accountType && this.accountType == Constants.VEHICLE_SERVICE_PROVIDER)
      return true;
    return false;
  }

  isRentalFleetAccount(): boolean {
    if (this.accountCategory && this.accountCategory == Constants.RENTAL_FLEET)
      return true;
    return false;
  }

  isDealerAccount(): boolean {
    if (this.accountCategory && this.accountCategory == Constants.DEALER)
      return true;
    return false;
  }

  isFleetManagementCompany(): boolean {
    if (this.accountCategory && (this.accountCategory == Constants.FLEET_MANAGEMENT_COMPANY || this.accountCategory == Constants.MOBILITY_COMPANY || this.accountCategory == Constants.FIELD_SERVICE_COMPANY))
      return true;
    return false;
  }

  isCorporateAccount(): boolean {
    if (this.accountCategory && (this.accountCategory == Constants.CORPORATE || this.accountCategory == Constants.FINANCING_GROUP))
      return true;
    return false;
  }

  initNavigationOptions() {
    this.authService.navigationOptions = [];
    if (this.authService.isFinanceAdmin()) {
      this.authService.navigationOptions.push(new NavigationOptions("Invoices", "assets/images/usage.png", "invoices", "/invoices", "View invoices"));
      this.authService.navigationOptions.push(new NavigationOptions("Support", "assets/images/question.png", "Support", "/support", "Access support services"));
    } else if (this.isRentalFleetAccount()) {
      this.authService.navigationOptions.push(new NavigationOptions("Account Management", "assets/images/b2b.png", "Account Management", "/account-management", "Manage vehicles and packages")); //Manage vehicles, packages and locations
      // this.authService.navigationOptions.push(new NavigationOptions("Usage", "assets/images/usage.png", "usage", "/usage", "View service usage"));
      // this.authService.navigationOptions.push(new NavigationOptions("Invoices", "assets/images/usage.png", "invoices", "/billing", "View invoices"));
      this.authService.navigationOptions.push(new NavigationOptions("Invoices", "assets/images/usage.png", "invoices", "/invoices", "View invoices"));
      this.authService.navigationOptions.push(new NavigationOptions("User Roles", "assets/images/users.png", "User Roles", "/admin-roles", "Add or manage users"));
      this.authService.navigationOptions.push(new NavigationOptions("Support", "assets/images/question.png", "Support", "/support", "Access support services"));
      this.authService.navigationOptions.push(new NavigationOptions("Settings", "assets/images/gear.png", "Settings", "/settings", "Manage account")); // & location settings
      // this.authService.navigationOptions.push(new NavigationOptions("Vehicle Journey", "assets/images/journey/vehicle-journey.png", "Vehicle Journey", "/vehicle-journey", "Vehicle Journey"));
      if (this.env.SHOW_STREAMING) this.authService.navigationOptions.push(new NavigationOptions("Streaming Data", "assets/images/streaming.png", "Streaming Data", "/streaming", "View Stream Data"));
      // this.authService.navigationOptions.push(new NavigationOptions("Dashboard", "assets/images/dashboard.png", "Dashboard", "/commercial-fleet-dashboard", "View fleet status and insights"));
    } else if (this.isFleetManagementCompany()) {
      // this.authService.navigationOptions.push(new NavigationOptions("Dashboard", "assets/images/dashboard.png", "Dashboard", "/commercial-fleet-dashboard", "View fleet status and insights"));
      // this.authService.navigationOptions.push(new NavigationOptions("Usage", "assets/images/usage.png", "usage", "/usage", "View service usage"));
      // this.authService.navigationOptions.push(new NavigationOptions("Invoices", "assets/images/usage.png", "invoices", "/billing", "View invoices"));
      this.authService.navigationOptions.push(new NavigationOptions("Account Management", "assets/images/b2b.png", "Account Management", "/account-management", "Manage vehicles, packages and locations"));
      this.authService.navigationOptions.push(new NavigationOptions("Invoices", "assets/images/usage.png", "invoices", "/invoices", "View invoices"));
      // this.authService.navigationOptions.push(new NavigationOptions("Insights", "assets/images/idea.png", "Insights", "/commercial-fleet/insights", "View fleet performance"));
      this.authService.navigationOptions.push(new NavigationOptions("User Roles", "assets/images/users.png", "User Roles", "/admin-roles", "Add or manage users"));
      this.authService.navigationOptions.push(new NavigationOptions("Support", "assets/images/question.png", "Support", "/support", "Access support services"));
      this.authService.navigationOptions.push(new NavigationOptions("Settings", "assets/images/gear.png", "Settings", "/settings", "Manage account & location settings"));
      // this.authService.navigationOptions.push(new NavigationOptions("Developer Access", "assets/images/developer-access.png", "Developer Access", "/commercial-fleet", "View and manage API access"));
    } else if (this.isServiceProviderAccount()) {
      this.authService.navigationOptions.push(new NavigationOptions("Account Management", "assets/images/b2b.png", "Account Management", "/service-provider/account-management", "Manage vehicles, packages"));
      // this.authService.navigationOptions.push(new NavigationOptions("Usage", "assets/images/usage.png", "usage", "/usage", "View service usage"));
      // this.authService.navigationOptions.push(new NavigationOptions("Invoices", "assets/images/usage.png", "invoices", "/billing", "View invoices"));
      this.authService.navigationOptions.push(new NavigationOptions("Invoices", "assets/images/usage.png", "invoices", "/invoices", "View invoices"));
      this.authService.navigationOptions.push(new NavigationOptions("User Roles", "assets/images/users.png", "User Roles", "/admin-roles", "Add or manage users"));
      this.authService.navigationOptions.push(new NavigationOptions("Support", "assets/images/question.png", "Support", "/support", "Access support services"));
      this.authService.navigationOptions.push(new NavigationOptions("Settings", "assets/images/gear.png", "Settings", "/settings", "Manage account & location settings"));
    } else if (this.authService.isDongleProvider()) {
      this.authService.navigationOptions.push(new NavigationOptions("Account Management", "assets/images/b2b.png", "Account Management", "/provider/account-management"));
      this.authService.navigationOptions.push(new NavigationOptions("User Roles", "assets/images/users.png", "User Roles", "/provider/user-roles"));
      // this.navigationOptions.push(new NavigationOptions("Support", "assets/images/question.png", "Support", "/provider/dashboard"));
      this.authService.navigationOptions.push(new NavigationOptions("Settings", "assets/images/gear.png", "Settings", "/provider/dashboard"));
    } else if (this.isDealerAccount()) {
      this.authService.navigationOptions.push(new NavigationOptions("Account Management", "assets/images/b2b.png", "Account Management", "/account-management", "Manage vehicles and packages")); //Manage vehicles, packages and locations
      this.authService.navigationOptions.push(new NavigationOptions("Business Entity", "assets/images/b2b.png", "Business Entity", "/business-entity", "View Business Entities"));
      // this.authService.navigationOptions.push(new NavigationOptions("Usage", "assets/images/usage.png", "usage", "/usage", "View service usage"));
      // this.authService.navigationOptions.push(new NavigationOptions("Invoices", "assets/images/usage.png", "invoices", "/billing", "View invoices"));
      this.authService.navigationOptions.push(new NavigationOptions("Invoices", "assets/images/usage.png", "invoices", "/invoices", "View invoices"));
      this.authService.navigationOptions.push(new NavigationOptions("User Roles", "assets/images/users.png", "User Roles", "/admin-roles", "Add or manage users"));
      this.authService.navigationOptions.push(new NavigationOptions("Support", "assets/images/question.png", "Support", "/support", "Access support services"));
      this.authService.navigationOptions.push(new NavigationOptions("Settings", "assets/images/gear.png", "Settings", "/settings", "Manage account")); // & location settings
      //this.authService.navigationOptions.push(new NavigationOptions("Vehicle Journey", "assets/images/journey/vehicle-journey.png", "Vehicle Journey", "/vehicle-journey", "Vehicle Journey"));
    } else if (this.isCorporateAccount()) {
      this.authService.navigationOptions.push(new NavigationOptions("Account Management", "assets/images/b2b.png", "Account Management", "/account-management", "Manage vehicles and packages")); //Manage vehicles, packages and locations
      // this.authService.navigationOptions.push(new NavigationOptions("Usage", "assets/images/usage.png", "usage", "/usage", "View service usage"));
      // this.authService.navigationOptions.push(new NavigationOptions("Invoices", "assets/images/usage.png", "invoices", "/billing", "View invoices"));
      this.authService.navigationOptions.push(new NavigationOptions("Invoices", "assets/images/usage.png", "invoices", "/invoices", "View invoices"));
      this.authService.navigationOptions.push(new NavigationOptions("User Roles", "assets/images/users.png", "User Roles", "/admin-roles", "Add or manage users"));
      this.authService.navigationOptions.push(new NavigationOptions("Support", "assets/images/question.png", "Support", "/support", "Access support services"));
      this.authService.navigationOptions.push(new NavigationOptions("Settings", "assets/images/gear.png", "Settings", "/settings", "Manage account")); // & location settings
      // this.authService.navigationOptions.push(new NavigationOptions("Vehicle Journey", "assets/images/journey/vehicle-journey.png", "Vehicle Journey", "/vehicle-journey", "Vehicle Journey"));
    }
  }

  routeToHomePage() {
    // var accountStatus = this.apiService.accountDetail.status;
    // if(true || accountStatus == Constants.INACTIVE || accountStatus == Constants.PENDING) {
    //   this.router.navigate(["/tnc"]);
    //   return;
    // }
    var accountCategory = this.apiService.accountDetail.category;
    if (accountCategory == Constants.RENTAL_FLEET) {
      this.homePageRoute = "/rental-fleet";
      this.router.navigate(["/rental-fleet"]);
    } else if (accountCategory == Constants.FLEET_MANAGEMENT_COMPANY || accountCategory == Constants.MOBILITY_COMPANY || accountCategory == Constants.FIELD_SERVICE_COMPANY) {
      this.homePageRoute = "/commercial-fleet";
      this.router.navigate(["/commercial-fleet"]);
    } else if (accountCategory == Constants.DEALER) {
      this.homePageRoute = "/dealer";
      this.router.navigate(["/dealer"]);
    } else if (this.accountType && this.accountType == Constants.VEHICLE_SERVICE_PROVIDER) {
      this.homePageRoute = "/service-provider/dashboard";
      this.router.navigate(["/service-provider/dashboard"]);
    }  else if (accountCategory == Constants.CORPORATE || accountCategory == Constants.FINANCING_GROUP) {
      this.homePageRoute = "/corporate";
      this.router.navigate(["/corporate"]);
    } else {
      this.homePageRoute = "/invalid";
      this.router.navigate(["/invalid"]);
    }
  }

  initHeaderTitle() {
    if (this.isAdmin || this.isFinanceAdmin) {
      if (this.accountCategory == Constants.RENTAL_FLEET) {
        this.loggedInUser = "Rental Fleet";
      } else if (this.accountCategory == Constants.FLEET_MANAGEMENT_COMPANY) {
        this.loggedInUser = "Commercial Fleet";
      } else if (this.accountCategory == Constants.DEALER) {
        this.loggedInUser = "Dealer";
      } else if (this.accountType && this.accountType == Constants.VEHICLE_SERVICE_PROVIDER) {
        this.loggedInUser = "Service Provider";
      } else if (this.accountCategory == Constants.CORPORATE) {
        this.loggedInUser = "Corporate";
      } else if (this.accountCategory == Constants.FINANCING_GROUP) {
        this.loggedInUser = "Financing Group";
      } else if (this.accountCategory == Constants.MOBILITY_COMPANY) {
        this.loggedInUser = "Mobility Company";
      }  else if (this.accountCategory == Constants.FIELD_SERVICE_COMPANY) {
        this.loggedInUser = "Field Service Company";
      } 
    } else if (this.isDeveloper) {
      this.loggedInUser = "Developer"
    } else if (this.authService.isDongleProvider()) {
      this.loggedInUser = "Dongle Provider"
    }
  }

  smSearchClicked() {
    this.issmSearchClicked = !this.issmSearchClicked;
  }

  openDeveloperAccess() {
    if (this.authService.loggedInUser == null)
      return;
    document.getElementById("openDeveloperAccess").click();
  }

  setShowSearchBox(): void {
    if (this.isDeveloper || this.isFinanceAdmin || !this.isAuthorized(this.accountDetailFromAPI)) {
      this.showSearchBox = false;
    } else this.showSearchBox = true;
  }

  setShowNotification(): void {
    if (this.isDeveloper || !this.isAuthorized(this.accountDetailFromAPI)) {
      this.showNotification = false;
    } else this.showNotification = true;
  }

  setShowNavigationOptions(): void {
    if (!this.isAuthorized(this.accountDetailFromAPI)) {
      this.showNavigationOptions = false;
    } else this.showNavigationOptions = true;
  }

  getWebNotificationsByStatus() {
    this.apiService.getWebNotificationsByStatus("UNREAD").then((data) => {
      this.notifications = data;
    }).catch((error) => {
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          this.getWebNotificationsByStatus();
        });
      }
    });
  }

  handleNotificationChanges() {
    this.notificationService.notificationUpdated.subscribe((res: any) => {
      this.getWebNotificationsByStatus();
    });
  }

  onRouteToHome() {
    // call me(profile) api, from auth service
    this.getAccountDetailForAdminType();
  }

  getAccountDetailForAdminType() {
    if (this.authService.isAdmin()) {
      this.isAdmin = true;
      this.getAccountDetail();
    } else if (this.authService.isDeveloper()) {
      this.isDeveloper = true;
      this.getAccountDetail();
    } else if (this.authService.isFinanceAdmin()) {
      this.isFinanceAdmin = true;
      this.getAccountDetail();
    }
  }

  onProfileUpdate() {
    console.log("On proifle update");
    this.getUpdatedLoggedinUserDetails();
  }

  initSmsMfaVerificationModel() {
    this.smsMfaVerificationModel = {
      "accessToken": null,
      "code": null
    }
    console.log("initSmsMfaVerificationModel : ", this.smsMfaVerificationModel);
  }

  resetSmsMfaVerificationForm() {
    if (this.smsMfaVerificationForm) {
      this.smsMfaVerificationForm.reset();
      this.smsMfaVerificationForm.resetForm();
    }
    this.initSmsMfaVerificationModel();
  }

  executeMfaFlow() {
    console.log("execute mfa logged in user profile : ", this.authService.loggedInUser);
    if (this.authService.loggedInUser.multiFactorAuthentication == Constants.ENABLED && !this.authService.loggedInUser.phoneNumberVerified && this.authService.loggedInUser.mfaPreference != "EMAIL") {
      console.log("Call generateMfaOtp api");
      this.generateMfaOtp();
    }
  }

  generateMfaOtp() {
    this.utilService.showSpinner();
    this.authService.generateMfaOtp().then((data) => {
      this.utilService.hideSpinner();
      console.log("generateMfaOtp response data::", data);
      this.smsMfaData = data;
      this.initSmsMfaVerificationModel();
      document.getElementById("openResendCodeModal").click();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.generateMfaOtp();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  mfaFormSubmit(form: NgForm): void {
    this.smsMfaVerificationForm = form;
    if (form.valid) {
      console.log("userVerificationModel::", this.smsMfaVerificationModel);
      this.validateLoggedinUserMfaCode();
    }
  }

  validateLoggedinUserMfaCode() {
    this.utilService.showSpinner();
    this.authService.validateLoggedinUserMfaCode(this.smsMfaVerificationModel).then((data) => {
      this.utilService.hideSpinner();
      console.log("validateLoggedinUserMfaCode response data::", data);
      this.toast.showSuccess(data.message);
      // this.resetSmsMfaVerificationForm();
      document.getElementById("closeVerifyCode").click();
      this.authService.getUserDetails();
      this.isPhoneNumberVerified = true;
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.validateLoggedinUserMfaCode();
        });
      }
      else {
        this.isPhoneNumberVerified = true;
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getUpdatedLoggedinUserDetails() {
    this.utilService.showSpinner();
    this.authService.getUserDetails().then((data) => {
      this.utilService.hideSpinner();
      console.log("getUpdatedLoggedinUserDetails ::", data);
      if (this.authService.loggedInUser.phoneNumberVerified) {
        this.isPhoneNumberVerified = true;
      } else {
        this.isPhoneNumberVerified = false;
      }
      this.executeMfaFlow();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getUpdatedLoggedinUserDetails();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  watchTokenKey() {
    let storageObservable: Observable<Event> = fromEvent(window, 'storage');
    storageObservable.pipe(delay(500)).subscribe(
      ldata => {
        let isUserLoggedIn = localStorage.getItem(this.authService.TOKEN_KEY);
        if (!isUserLoggedIn) {
          this.authService.logout();
        }
      }
    );
  }

  showUserPreferenceModal() {
    // this.userLanguagePreferenceComponent.init();
    this.onRouteToHome();
  }

  getPackageList() {
    this.utilService.showSpinner();
    this.apiService.getAccountServicePackageList().then((data) => {
      this.utilService.hideSpinner();
      console.log("service package from API::", data);
      this.checkAccountPackageProductCategories(data);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getPackageList();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  checkAccountPackageProductCategories(packages) {
    var packageProductCategories = [];
    if (packages && packages.length > 0) {
      packageProductCategories = [...new Set(packages.map(obj => obj['productCategory']))];
    }

    //For testing:
    // packageProductCategories = [
    //   Constants.PACKAGE_PRODUCT_CATEGORY_SERVICE,
    //   Constants.PACKAGE_PRODUCT_CATEGORY_FLEET_APP,
    //   Constants.PACKAGE_PRODUCT_CATEGORY_MOBILITY_APP
    // ];

    var isShowDeveloperUser = true;

    if (packageProductCategories && packageProductCategories.length > 0) {
      if (packageProductCategories.includes(Constants.PACKAGE_PRODUCT_CATEGORY_FLEET_APP) || packageProductCategories.includes(Constants.PACKAGE_PRODUCT_CATEGORY_MOBILITY_APP))
        isShowDeveloperUser = false;
    }

    this.authService.accountData["packageProductCategories"] = packageProductCategories;
    this.authService.accountData["isShowDeveloperUser"] = isShowDeveloperUser;

    console.log("20240507 updated accountData: ", this.authService.accountData);
  }
}
